import dayjs from 'dayjs';

export const datePickerDayClassName: (date: Date) => string = date => {
   const isCurrentDate = dayjs(date).isSame(dayjs(), 'date');
   return isCurrentDate ? 'current' : '';
};
